/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { RemoveAuthSupportRequestBody } from '../../models/remove-auth-support-request-body';

export interface RemoveAuthSupportsFromSubscription$Params {

/**
 * The object ID. Must be a valid ID.
 */
  uid: string;
      body: RemoveAuthSupportRequestBody
}

export function removeAuthSupportsFromSubscription(http: HttpClient, rootUrl: string, params: RemoveAuthSupportsFromSubscription$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
  const rb = new RequestBuilder(rootUrl, removeAuthSupportsFromSubscription.PATH, 'post');
  if (params) {
    rb.path('uid', params.uid, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'text', accept: '*/*', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
    })
  );
}

removeAuthSupportsFromSubscription.PATH = '/subscriptions/{uid}/auth-supports/remove';
